import App from '@/models/App'

import Organization from '@/models/Organization'
import Ship from '@/models/Ship'
import ShipSailor from '@/models/ShipSailor'

export default class ShipLaborBoarding extends App {
    static get entity() {
        return 'ShipLaborBoardings'
    }
    static all() {
        return this.query().withAllRecursive().get()
    }
    static get() {
        return this.query()
            .withAllRecursive()
            .get()
            .filter((item) => {
                return !item.isDeleted
            })
    }
    static getLatestOrder(shipSailorId) {
        return this.query()
            .where('isDeleted', false)
            .where('shipSailorId', shipSailorId)
            .orderBy('boardingAt', 'desc')
            .get()
    }
    static one() {
        return this.query().first()
    }
    static fields() {
        return {
            id: this.attr(''),
            organizationId: this.attr(''),
            shipId: this.attr(''),
            shipSailorId: this.attr(''),
            boardingAt: this.attr(''),
            disembarkAt: this.attr(''),
            isDisembarked: this.attr(true),
            boardingPort: this.attr(''),
            disembarkPort: this.attr(''),
            isDeleted: this.attr(false),
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
            boardingShipName: this.attr(''),
            organization: this.belongsTo(Organization, 'organizationId'),
            // TODO: 招待されてない船が出てきちゃうので一旦コメントアウト mtsm-todo: 新しい船員一覧APIできたら全体調整
            // ship: this.belongsTo(Ship, 'shipId'),
            // TODO: バックエンドで無限ループしてしまうのでコメントアウト
            // shipSailor: this.belongsTo(Ship, 'shipSailorId'),
        }
    }

    static getOtherHistories(shipSailorId, shipLaborBoardingId) {
        return this.query()
            .where((value) => {
                return (
                    value.shipSailorId === shipSailorId &&
                    value.id !== shipLaborBoardingId &&
                    value.isDeleted == false
                )
            })
            .withAllRecursive()
            .get()
    }

    static apiConfig = {
        actions: {
            fetch() {
                return this.get(`/labor/boardings`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.attendURL(),
                })
            },
            fetchByShip(shipId, sailorId) {
                return this.get(
                    `${shipId}/sailors/${sailorId}/labor/boardings`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            boarding(shipId, sailorId, params = {}) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.post(
                    `${shipId}/sailors/${sailorId}/labor/boardings`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            disembark(shipId, sailorId, shipLaborBoardingId) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.patch(
                    `${shipId}/sailors/${sailorId}/labor/boardings/${shipLaborBoardingId}/disembarks`,
                    {},
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            attendDisembark(sailorId, shipLaborBoardingId) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.patch(
                    `${sailorId}/labor/boardings/${shipLaborBoardingId}/disembarks`,
                    {},
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.attendURL(),
                    }
                )
            },
            update(shipId, shipSailorId, shipLaborBoardingId, params) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.patch(
                    `${shipId}/sailors/${shipSailorId}/boardings/${shipLaborBoardingId}`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(shipId, shipSailorId, shipLaborBoardingId) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.delete(
                    `${shipId}/sailors/${shipSailorId}/boardings/${shipLaborBoardingId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
